import TasksLogs from "Areas/SharedFeatures/tasksLogs";
import filterByText from "Common/componentUtils/filterByText";
import sort from "Common/componentUtils/sort";
import usePrevious from "Common/componentUtils/usePrevious";
import { SORT_ORDER } from "Common/dictionaries/sortOrder";
import { withOverlaysProvider } from "Components/overlaysContext";
import ProgressOverlay from "Components/progressOverlay";
import WelcomePanel from "Components/welcomePanel";
import classNames from "classnames";
import debounce from "lodash/debounce";
import filter from "lodash/filter";
import forEach from "lodash/forEach";
import includes from "lodash/includes";
import map from "lodash/map";
import reject from "lodash/reject";
import some from "lodash/some";
import VirtualScrollList from "rc-virtual-list";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useResizeDetector } from "react-resize-detector";
import Task from "./task";
import locale from "./tasks.inner.locale";
import Styled, { SIZES } from "./tasks.inner.styled";
function TasksInner(props) {
    const [opened, setOpened] = useState([]);
    const [filterText, setFilterText] = useState(props.filterText);
    const prevFilterText = usePrevious(filterText);
    const [tasks, setTasks] = useState(undefined);
    const { height, ref: observableRef } = useResizeDetector();
    const wasInitialized = useRef(false);
    useEffect(() => {
        var _a;
        if (wasInitialized.current && ((_a = props.outdated) === null || _a === void 0 ? void 0 : _a.length) && props.onGetRequestTask) {
            forEach(props.outdated, id => {
                props.onGetRequestTask && props.onGetRequestTask(id);
            });
        }
    }, [props.outdated]);
    useEffect(() => {
        if (props.documentId && props.onInitialized) {
            props.onInitialized(props.documentId);
            wasInitialized.current = true;
        }
        return () => {
            wasInitialized.current = false;
        };
    }, [props.documentId, props.onInitialized]);
    const emptyText = props.documentId ? locale.NO_DOCUMENT_TASKS : locale.SELECT_DOCUMENT;
    const filterChangedCallback = useCallback(debounce((text) => {
        setFilterText(text);
    }, 250), []);
    useEffect(() => {
        filterChangedCallback(props.filterText);
    }, [props.filterText]);
    useEffect(() => {
        if (!props.documentId) {
            setTasks([]);
            return;
        }
        if (!props.tasks) {
            setTasks(undefined);
            return;
        }
        const newItems = sort(map(filter(props.tasks, e => filterByText(filterText, e.Name) ||
            some(e.SubTasks, s => filterByText(filterText, s.Name))), e => ({
            ...e,
            SubTasks: sort(filter(e.SubTasks, s => filterByText(filterText, s.Name)), props.sortBy, props.sortOrder)
        })), props.sortBy, props.sortOrder);
        setTasks(newItems);
        if (prevFilterText !== filterText) {
            setOpened(filterText ? map(newItems, "Id") : []);
        }
    }, [props.tasks, props.documentId, filterText, props.sortBy, props.sortOrder]);
    const handleScroll = useCallback(() => {
        props.hidePopoverOverlays && props.hidePopoverOverlays();
    }, [props.hidePopoverOverlays]);
    const handleOpenedChanged = useCallback((id) => {
        setOpened(prev => (includes(prev, id) ? reject(prev, p => p === id) : [...(prev || []), id]));
    }, []);
    return (React.createElement(ProgressOverlay, { show: props.inProgress, className: classNames("overflow-hidden", props.className), overlayStyle: props.progressOverlayStyle },
        React.createElement(Styled.ItemsContainer, { className: "stretched-to-fit overflow-hidden", ref: observableRef },
            (tasks === null || tasks === void 0 ? void 0 : tasks.length) ? (React.createElement(VirtualScrollList, { className: "pl-1 unselectable text-white", data: tasks, height: height, itemHeight: SIZES.MIN_ITEM_HEIGHT + SIZES.ITEMS_GAP, itemKey: "Id", onScroll: handleScroll }, item => (React.createElement("div", { className: "virtual-row mr-1" },
                React.createElement(Task, { className: "bg-new-gray", actionIconColor: "#5B21D41F", data: item, filterText: filterText, opened: includes(opened, item.Id), onOpenedToggle: handleOpenedChanged, showedResultsSourceTaskIds: props.showedResultsSourceTaskIds, onToggleShowHideResults: props.onToggleShowHideResults, onTaskLogOpen: props.onTaskLogOpen, onStopRequestTask: props.onStopRequestTask, onRestartRequestTask: props.onRestartRequestTask, onHighlightTaskResults: props.onHighlightTaskResults }))))) : ((tasks === null || tasks === void 0 ? void 0 : tasks.length) === 0 && (React.createElement(WelcomePanel, { message: emptyText, showIcon: false, messageMuted: false, messageClassName: "font-h5 text-gray-500" }))),
            React.createElement(TasksLogs, null))));
}
const TasksInnerWithOverlaysProvider = withOverlaysProvider(TasksInner);
export default TasksInnerWithOverlaysProvider;
TasksInnerWithOverlaysProvider.defaultProps = {
    sortOrder: SORT_ORDER.DESC,
    sortBy: "Date"
};
